import { combineLatest as observableCombineLatest } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, ValidatorFn, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { StoresService } from '../../../core/services/stores.service';
import { BsLocaleService, BsDatepickerInputDirective, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from '../../../core/services/tools.service';
import { UserService } from '../../../core/services/user.service';
import { first } from 'rxjs';
import { add, format, startOfDay, isBefore, parse, set } from 'date-fns';
import { CalendarService } from '../../../dashboard/services/calendar.service';
import { IntlService } from '../../../core/services/intl.service';
import { NgClass, DatePipe } from '@angular/common';
import { LoaderComponent } from '../../../shared-with-client/loader/loader.component';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { MobileDatePickerComponent } from '../../mobile-date-picker/mobile-date-picker.component';
import { DropdownInputComponent } from '../../../shared-with-client/dropdown-input/dropdown-input.component';
import { AlertComponent } from '../../../shared-with-client/alert/alert.component';
import { TextInputComponent } from '../../../shared-with-client/text-input/text-input.component';
import { SubmitBtnComponent } from '../../../shared-with-client/submit-btn/submit-btn.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-create-holiday-modal',
    templateUrl: './create-holiday-modal.component.html',
    styleUrls: ['./create-holiday-modal.component.scss'],
    imports: [LoaderComponent, FormsModule, ReactiveFormsModule, BsDatepickerInputDirective, BsDatepickerDirective, NgxIntlTelInputModule, MobileDatePickerComponent, DropdownInputComponent, AlertComponent, TextInputComponent, NgClass, SubmitBtnComponent, DatePipe, TranslatePipe],
    standalone: true
})
export class CreateHolidayModalComponent implements OnInit {
  public dateInitDayPickerMobile = false;
  public dateEndDayPickerMobile = false;
  public recurrentUntilPickerMobile = false;

  public initialRequests;

  public event;

  public form: UntypedFormGroup;
  public loading = true;
  public day;
  public providers;
  public storeSlug;
  public store;
  public openTimes;

  public availableHours = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
  ];
  public availableMinutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

  public saving;
  public submitAttempted = false;
  public errorMsg;

  // public deleteModalRef: BsModalRef;
  public bsConfig = {
    dateInputFormat: 'DD/MM/YYYY',
    showWeekNumbers: false,
    adaptivePosition: true,
  };

  public minDate = new Date();

  public recurrentOptions;

  public isRecurrent = false;

  public defaultProviderId = null;
  public defaultStartHour = null;
  public defaultStartMinutes = null;
  public defaultEndHour = null;
  public defaultEndMinutes = null;
  public user;

  public flexibleHours = 2;
  public flexibleMinutes = 120;
  public allProvidersOption: { id: number; name: any; };

  constructor(
    private fb: UntypedFormBuilder,
    private bsModalRef: BsModalRef,
    private datePickerLocaleService: BsLocaleService,
    private storesService: StoresService,
    private modalService: BsModalService,
    private translate: TranslateService,
    private userService: UserService,
    private toolsService: ToolsService,
    private calendarService: CalendarService,
    private intlService: IntlService
  ) {

    this.datePickerLocaleService.use(this.intlService.getCurrentLanguage());

  }

  ngOnInit() {
    this.availableHours = this.availableHours.map(t => format(parse(t, 'HH', new Date()), this.intlService.getTimeFormatHour()));
    this.recurrentOptions = [
      { value: 1, name: this.translate.instant('SHARED.createHolidayModal.everyWeek') },
      { value: 2, name: this.translate.instant('SHARED.createHolidayModal.everyNWeek', { N: 2 }) },
      { value: 3, name: this.translate.instant('SHARED.createHolidayModal.everyNWeek', { N: 3 }) },
      { value: 4, name: this.translate.instant('SHARED.createHolidayModal.everyNWeek', { N: 4 }) },
      { value: 5, name: this.translate.instant('SHARED.createHolidayModal.everyNWeek', { N: 5 }) },
      { value: 6, name: this.translate.instant('SHARED.createHolidayModal.everyNWeek', { N: 6 }) },
      { value: 7, name: this.translate.instant('SHARED.createHolidayModal.everyNWeek', { N: 7 }) },
      { value: 8, name: this.translate.instant('SHARED.createHolidayModal.everyNWeek', { N: 8 }) },
    ];

    this.allProvidersOption = { id: -1, name: this.translate.instant('SHARED.createHolidayModal.allProviders') };

    this.storesService
      .getStoreId(this.storeSlug)
      .pipe(first())
      .subscribe((id) => {
        this.userService.currentUser.subscribe((res) => {
          this.user = res;
        });
        this.initialRequests = observableCombineLatest([
          this.storesService.getStore(this.storeSlug).pipe(first()),
          this.storesService.getStoreProviders(id),
        ]);

        this.initialRequests.subscribe((res) => {
          this.store = res[0];
          if (this.user?.role === 'provider') {
            // do not show all providers option
            this.providers = [...res[1]];
          } else {
            this.providers = [this.allProvidersOption, ...res[1]];
          }
          this.loading = false;
          this.generateForm(this.event);
        });
      });

  }

  generateForm(data = null) {
    this.generateAvailableTimesForSelectedDay();

    let defaultDay = new Date();
    if (this.day) {
      defaultDay = parse(this.day, 'yyyy-MM-dd', new Date());
    }
    const defaultDayEnd = defaultDay;

    let defaultStartHour, defaultStartMinutes;
    if (this.defaultStartHour && this.defaultStartMinutes) {
      defaultStartHour = format(parse(this.defaultStartHour, 'HH', new Date()), this.intlService.getTimeFormatHour());
      defaultStartMinutes = this.defaultStartMinutes;
    } else {
      defaultStartHour = format(add(set(new Date(), { minutes: 0 }), { hours: 1 }), this.intlService.getTimeFormatHour());
      defaultStartMinutes = format(add(set(new Date(), { minutes: 0 }), { hours: 1 }), 'mm');
    }
    const defaultEndHour = format(add(parse(`${defaultStartHour}:${defaultStartMinutes}`, `${this.intlService.getTimeFormatHour()}:mm`, new Date()), { hours: 1 }), this.intlService.getTimeFormatHour());
    const defaultEndMinutes = format(add(parse(`${defaultStartHour}:${defaultStartMinutes}`, `${this.intlService.getTimeFormatHour()}:mm`, new Date()), { hours: 1 }), 'mm');

    // dateInit, dateEnd, storeId, providerId, reason
    this.form = this.fb.group(
      {
        dateInitDay: [(data && parse(data.dateInit, 'yyyy-MM-dd HH:mm', new Date())) || defaultDay, data ? [Validators.required] : []],
        dateEndDay: [(data && parse(data.dateEnd, 'yyyy-MM-dd HH:mm', new Date())) || defaultDayEnd, data ? [Validators.required] : []],
        dateInitTimeHour: [
          (data && data.dateInit && format(parse(data.dateInit, 'yyyy-MM-dd HH:mm', new Date()), this.intlService.getTimeFormatHour())) || defaultStartHour,
          [Validators.required],
        ],
        dateInitTimeMinutes: [
          (data && data.dateInit && format(parse(data.dateInit, 'yyyy-MM-dd HH:mm', new Date()), 'mm')) || defaultStartMinutes,
          [Validators.required],
        ],
        dateEndTimeHour: [(data && data.dateEnd && format(parse(data.dateEnd, 'yyyy-MM-dd HH:mm', new Date()), this.intlService.getTimeFormatHour())) || defaultEndHour],
        dateEndTimeMinutes: [
          (data && data.dateEnd && format(parse(data.dateEnd, 'yyyy-MM-dd HH:mm', new Date()), 'mm')) || defaultEndMinutes,
        ],
        provider: [(data && data.provider && data.provider.name) || this.checkDefaultProvider() || this.allProvidersOption.name, []],
        reason: [(data && data.reason) || '', [Validators.maxLength(500)]],
        recurrent: [this.recurrentOptions[0].name, []],
        recurrentUntil: [null, []],
        recurrentCheck: [false, []],
      },
      { validators: [this.endDateValidator()] }
    );
  }

  endDateValidator(): ValidatorFn {
    return (group: UntypedFormGroup) => {
      const dateInitDay = group.controls['dateInitDay'].value;
      const dateEndDay = group.controls['dateEndDay'].value;

      const dateInitTimeHour = format(parse(group.controls['dateInitTimeHour'].value, this.intlService.getTimeFormatHour(), new Date()), 'HH');
      const dateInitTimeMinutes = group.controls['dateInitTimeMinutes'].value;
      const dateEndTimeHour = format(parse(group.controls['dateEndTimeHour'].value, this.intlService.getTimeFormatHour(), new Date()), 'HH');
      const dateEndTimeMinutes = group.controls['dateEndTimeMinutes'].value;

      const dateInit = set(dateInitDay, { hours: Number(dateInitTimeHour), minutes: dateInitTimeMinutes });
      const dateEnd = set(dateEndDay, { hours: Number(dateEndTimeHour), minutes: dateEndTimeMinutes })

      if (isBefore(dateInit, dateEnd)) {
        return null;
      } else {
        return {
          invalidEndDate: true,
        };
      }
    };
  }

  generateAvailableTimesForSelectedDay() {
    const bookingFrequency = this.storesService.getBookingFrequencyForCalendar(this.store.bookingFrequency);

    this.openTimes = this.calendarService.generateAvailableTimesForSelectedDay(
      true,
      bookingFrequency,
      this.day,
      this.store,
      this.flexibleHours,
      this.flexibleMinutes,
      this.event
    );
    return;
  }

  checkDefaultProvider() {
    if (this.user?.role === 'provider') {
      this.defaultProviderId = this.user?.roleProviderId;
      return this.providers[0].name;
    }

    if (this.defaultProviderId) {
      return this.providers.find((p) => p.id === this.defaultProviderId)?.name;
    }

    return null;
  }

  getIdFromProviderName(name) {
    return this.providers.find((v) => v.name === name)?.id;
  }

  save() {
    this.submitAttempted = true;
    this.errorMsg = null;

    if (!this.form.valid) {
      return false;
    }

    this.saving = true;

    const dateInitDay =
      (this.form.get('dateInitDay').value && format(new Date(this.form.get('dateInitDay').value), 'yyyy-MM-dd')) || this.day;
    const dateEndDay = (this.form.get('dateEndDay').value && format(new Date(this.form.get('dateEndDay').value), 'yyyy-MM-dd')) || this.day;

    const recurrenceString = this.form.get('recurrent').value;
    const recurrenceValue = this.recurrentOptions.filter((option) => option.name === recurrenceString)[0].value;

    const payload = {
      dateInit: dateInitDay + ' '
        + format(parse(this.form.get('dateInitTimeHour').value, this.intlService.getTimeFormatHour(), new Date()), 'HH')
        + ':' + this.form.get('dateInitTimeMinutes').value,
      dateEnd: dateEndDay + ' '
        + format(parse(this.form.get('dateEndTimeHour').value, this.intlService.getTimeFormatHour(), new Date()), 'HH')
        + ':' + this.form.get('dateEndTimeMinutes').value,
      reason: this.form.get('reason').value,
      providerId: null,
      storeId: null,
    };

    if (this.isRecurrent) {
      payload['recurrence'] = recurrenceValue;
      payload['recurrenceEndDate'] = this.form.get('recurrentUntil').value
        ? format(new Date(this.form.get('recurrentUntil').value), 'yyyy-MM-dd')
        : null;
    }

    if (this.form.get('provider').value) {
      const providerId = this.getIdFromProviderName(this.form.get('provider').value);
      if (!providerId || providerId === -1) {
        payload.storeId = this.store.id;
      } else {
        payload.providerId = providerId;
      }
    } else {
      payload.storeId = this.store.id;
    }

    if (this.event) {
      // UPDATE EVENT

      this.storesService.editHoliday(this.event.id, payload).subscribe(
        (res) => {
          this.saving = false;
          this.modalService.setDismissReason('saved');
          this.bsModalRef.hide();
        },
        (err) => {
          this.errorMsg = err;
          this.saving = false;
        }
      );
    } else {
      // CREATE EVENT
      this.storesService.createHoliday(payload).subscribe(
        () => {
          this.saving = false;
          this.modalService.setDismissReason('saved');
          this.bsModalRef.hide();
        },
        (err) => {
          this.errorMsg = err.errMsg;
          this.saving = false;
        }
      );
    }
  }

  deleteHoliday() {
    this.modalService.setDismissReason('delete');
    this.bsModalRef.hide();
  }

  close() {
    this.bsModalRef.hide();
  }

  toggleRecurrent(event) {
    this.isRecurrent = !this.isRecurrent;
    if (this.isRecurrent) {
      this.form.controls['recurrentUntil'].setValidators([Validators.required]);
      this.form.controls['recurrentUntil'].updateValueAndValidity();
    } else {
      this.form.controls['recurrentUntil'].setValidators([]);
      this.form.controls['recurrentUntil'].updateValueAndValidity();
    }
  }

  canDeleteEvent() {
    if (!this.event) {
      return false;
    }
    if (!this.event.provider) {
      if (this.user?.role === 'provider') {
        return false;
      }
    }

    if (this.user?.role === 'provider' && !this.store?.allowProvidersToCreateHolidays) {
      return false;
    }

    return true;
  }

  canCreateEvent() {
    if (this.user?.role === 'provider' && !this.store?.allowProvidersToCreateHolidays) {
      return false;
    }

    return true;
  }
}
